import * as React from 'react';

const ModalFrameTabs = ({
  children
}: {
  children: React.ReactNode
}) => (
  <div
    className="modal-frame-tabs"
  >
    {children}
  </div>
);

export default ModalFrameTabs;
